module.exports = __webpack_public_path__ + "img/stones-2.26d4774.webp";